export enum RenderParams{
    Max_Active_Texture_Count,//可激活的纹理数量，即shader中的最大纹理数量
    Max_Uniform_Count,//最大Uniform数量
    Max_AnisoLevel_Count,//最大各向异性数量
    MAX_Texture_Size,//Shader中的最大纹理
    MAX_Texture_Image_Uint,//图形设备支持的最大纹理数量。
    SHADER_CAPAILITY_LEVEL,//Shader质量
    FLOAT,
    UNSIGNED_BYTE,
    BYTE,
    UNSIGNED_SHORT,
}